import React from 'react'

export function IconUserSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        d="M3.38505 10.321C2.44187 10.8826 -0.0310903 12.0293 1.47511 13.4643C2.21087 14.1653 3.03033 14.6666 4.06058 14.6666H9.93942C10.9697 14.6666 11.7891 14.1653 12.5249 13.4643C14.0311 12.0293 11.5581 10.8826 10.615 10.321C8.40321 9.00401 5.59679 9.00401 3.38505 10.321Z"
        stroke="#896145"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.33325C10 5.99011 8.65685 7.33325 7 7.33325C5.34315 7.33325 4 5.99011 4 4.33325C4 2.6764 5.34315 1.33325 7 1.33325C8.65685 1.33325 10 2.6764 10 4.33325Z"
        stroke="#896145"
        strokeWidth="1.5"
      />
    </svg>
  )
}
